import { render } from "./FinalSalaryEditor.vue?vue&type=template&id=ed54fe06&ts=true"
import script from "./FinalSalaryEditor.vue?vue&type=script&lang=ts"
export * from "./FinalSalaryEditor.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__